// tslint:disable: max-line-length
import React from "react"

export default function Bed() {
  return (
    <symbol id="svg-bed" viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M250.5 155h25.4c3.3 0 6 2.7 6 6v25.4c0 3.3 2.7 6 6 6H317c3.3 0 6-2.7 6-6V161c0-3.3 2.7-6 6-6h25.4c3.3 0 6-2.7 6-6v-29.2c0-3.3-2.7-6-6-6H329c-3.3 0-6-2.7-6-6V82.5c0-3.3-2.7-6-6-6h-29.2c-3.3 0-6 2.7-6 6v25.4c0 3.3-2.7 6-6 6h-25.4c-3.3 0-6 2.7-6 6V149c.1 3.3 2.8 6 6.1 6zm250 84.5H189.6c13.2-27.1-6.7-58.8-36.8-58.8-49.2 0-53-1.2-63.8 4.1v-15.3c0-6.4-5.2-11.5-11.5-11.5h-66C5.2 158 0 163.2 0 169.6V424c0 6.4 5.2 11.5 11.5 11.5h65.9c6.4 0 11.5-5.2 11.5-11.5v-28.1h334V424c0 6.4 5.2 11.5 11.5 11.5h65.9c6.4 0 11.5-5.2 11.5-11.5V251.1c.2-6.4-5-11.6-11.3-11.6zM65.9 412.4H23V181.1h42.9v231.3zm162.5-149.8H423v69.2H228.4v-69.2zm-121.5-58.8h45.9c9.9 0 17.9 8 17.9 17.9s-8 17.9-17.9 17.9h-45.9c-9.9 0-17.9-8-17.9-17.9 0-9.9 8-17.9 17.9-17.9zM89 262.6h116.4v69.2H89v-69.2zm334 110.2H89v-18h334v18zm66 39.6h-42.9V262.5H489v149.9z"
      />
    </symbol>
  )
}
